import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import { useAppContext } from "components/AppContext"
import ChartODD13GHGEmissionsBreakdownPurchasesByAllocationMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsBreakdownPurchasesByAllocationMolecule"
import ChartODD13GHGEmissionsBreakdownPurchasesByProviderMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsBreakdownPurchasesByProviderMolecule"
import ChartODD13GHGEmissionsBreakdownPurchasesByCategoryMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsBreakdownPurchasesByCategoryMolecule"
import TextChartODD13GHGEmissionsFactorAverage from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsFactorAverage"
import TextChartODD13GHGEmissionsPerServiceAverage from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsPerServiceAverage"
import TextChartOdd13GhgEmissionTab from "views/molecules/canvases/charts/TextChartODD13GHGEmissionTab"

const Objective13PurchasesOrganism = ({ score }) => {
  const { score: globalScore } = useAppContext()

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_purchased_it_services_CO2
  const chart2TrendBadge = globalScore?.trend_badges?.odd13_purchased_it_services_emission_factor
  const chart5TrendBadge = globalScore?.trend_badges?.odd13_purchased_it_services_emissions_per_service

  return (
    <ScoreLayoutOrganism
      chart1={
        <TextChartOdd13GhgEmissionTab
          ghgEmissions={score?.odd13_purchased_it_services_CO2}
          ghgEmissionsCollect={score?.odd13_CO2}
          hidePercentage={!score?.should_diplay_percentage}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={<TextChartODD13GHGEmissionsFactorAverage trendBadge={chart2TrendBadge} />}
      chart3={<ChartODD13GHGEmissionsBreakdownPurchasesByCategoryMolecule />}
      chart4={<ChartODD13GHGEmissionsBreakdownPurchasesByProviderMolecule />}
      chart5={<TextChartODD13GHGEmissionsPerServiceAverage trendBadge={chart5TrendBadge} />}
      chart6={<ChartODD13GHGEmissionsBreakdownPurchasesByAllocationMolecule />}
    />
  )
}

Objective13PurchasesOrganism.propTypes = {
  score: PropTypes.object.isRequired,
}

Objective13PurchasesOrganism.defaultProps = {}

export default Objective13PurchasesOrganism
